import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const TajweedBarchart = ({ data, level }) => {
  const levelColors = {
    1: "#2196F3", // blue
    2: "#00E676", // green
    3: "#9C27B0", // purple
    4: "#009688", // orange
  };

  return (
    <div className=" bg-gradient-to-tl from-slate-200 to-blue-100 rounded">
      <ResponsiveContainer height={200}>
        <BarChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis type="number" domain={[0, 100]} />
          <YAxis />
          <Tooltip />
          <Bar dataKey="Score" fill={levelColors[level] || "#2196F3"} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TajweedBarchart;
